import { graphConfig } from "../authConfig";
import { IPublicClientApplication } from "@azure/msal-browser";
import { Constants } from "../Constants";
import { StorageService } from "./StorageService";
import { minutesToMilliseconds } from "../utils/ConvertTime";
import { BaseService } from "./BaseService";

export interface ProfileAvatarData {
    initials: string,
    profileImageUrl: string,
}

export class ProfileService extends BaseService {

    public getProfileAvatarData = async (instance: IPublicClientApplication) => {

        const storageService = new StorageService();
        const responseData: ProfileAvatarData = { initials: '', profileImageUrl: '' };

        const account = instance.getActiveAccount();

        if (account && account.name) {
            const nameArray = account.name.split(" ");
            responseData.initials = nameArray
                .map((name: string) => name.charAt(0).toUpperCase())
                .join("");
        }

        const storageImageUrl = storageService.get(Constants.storage.keys.profileImage);
        if (!!storageImageUrl) {

            responseData.profileImageUrl = storageImageUrl === Constants.storage.values.profileImage404Value ?
                "" : 
                storageImageUrl as string;

            return responseData;
        }

        const headers = await this.getAuthorizedRequestHeaders(instance);
        const options = {
            method: "GET",
            headers: headers
        };

        const profileImage = await fetch(graphConfig.graphProfileImageEndpoint, options).then(value => {
            if(value.status === 404){
                return Constants.storage.values.profileImage404Value;
            }
            return value.status === 200 ? value : null;

        }).catch(error => {
            console.log("Profile Image", error)
        });

        if (profileImage) {
            responseData.profileImageUrl = profileImage === Constants.storage.values.profileImage404Value ? 
                profileImage : 
                await (profileImage as Response).text();
        
            storageService.set(Constants.storage.keys.profileImage, responseData.profileImageUrl, minutesToMilliseconds(Constants.storage.expiry.profileImage))
        }

        return responseData;
    }

    public getProfileData = async (instance: IPublicClientApplication) => {

        const headers = await this.getAuthorizedRequestHeaders(instance);
        const options = {
            method: "GET",
            headers: headers
        };

        const graphData = await fetch(graphConfig.graphMeEndpoint, options)
            .then(response => response.json()).catch(error => console.log(error));

        return graphData;
    }
}